import React from 'react';
import PropTypes from 'prop-types';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const ExistingMembershipDisplay = ({
  membership,
  membershipProduct,
  venueOwnership,
  team,
  onBuyAsGift = null
}) => {
  const isActive = membership.status === 'active' || membership.status === 'trialing';

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <div>
      <div className="row">
        <div className="col">
          <p className="mb-3 mt-1 text-dark" style={{ fontSize: "24px" }}>
            <strong>You're Already a Member</strong>
          </p>
        </div>
      </div>

      <div className="row" style={{ marginTop: "13px" }}>
        <div className="col-12 col-md-6 col-lg-8 mb-3">
          <div
            className="alert border-0 text-white mb-4"
            style={{ background: isActive ? "#28a745" : "#ffc107" }}
            role="alert"
          >
            <i className={`fas ${isActive ? 'fa-check-circle' : 'fa-info-circle'} mr-2`}></i>
            {isActive ? (
              <>You have an active membership for <strong>{membershipProduct.name}</strong>.</>
            ) : (
              <>Your membership for <strong>{membershipProduct.name}</strong> is currently {membership.status.replace('_', ' ')}.</>
            )}
          </div>

          <div className="card" style={{ border: "1px solid #e6e6e6" }}>
            <div className="card-body">
              <h5 className="card-title mb-3">
                <strong>Your Membership Details</strong>
              </h5>

              {membership.email && (
                <>
                  <div className="row mb-2">
                    <div className="col-6 text-muted">Member Name</div>
                    <div className="col-6">{membership.first_name} {membership.last_name}</div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-6 text-muted">Email</div>
                    <div className="col-6">{membership.email}</div>
                  </div>
                </>
              )}

              <div className="row mb-2">
                <div className="col-6 text-muted">Membership</div>
                <div className="col-6">{membershipProduct.name}</div>
              </div>

              <div className="row mb-2">
                <div className="col-6 text-muted">Status</div>
                <div className="col-6">
                  <span className={`badge ${isActive ? 'badge-success' : 'badge-warning'}`}>
                    {membership.status.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-6 text-muted">Billing</div>
                <div className="col-6">
                  {membership.price_to_currency || formatter.format(membership.price)} / {membership.interval_label || membership.interval}
                </div>
              </div>

              {membership.current_period_end && isActive && (
                <div className="row mb-2">
                  <div className="col-6 text-muted">{membership.canceled_at ? 'Expires on' : 'Next Billing Date'}</div>
                  <div className="col-6">{formatDate(membership.current_period_end)}</div>
                </div>
              )}

              {membership.created_at && (
                <div className="row">
                  <div className="col-6 text-muted">Member Since</div>
                  <div className="col-6">{formatDate(membership.created_at)}</div>
                </div>
              )}
            </div>
          </div>

          <div className="mt-4">
            <a href="/my_memberships" className="btn btn-outline-secondary" target="_blank" rel="noopener noreferrer">
              View My Memberships
            </a>
            {onBuyAsGift && (
              <button type="button" className="btn btn-danger ml-2" onClick={onBuyAsGift}>
                Buy one as a gift
              </button>
            )}
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4 mb-3 order-first order-md-last">
          {membershipProduct.image_url && (
            <img
              src={membershipProduct.image_url}
              className="img-fluid rounded"
              alt={membershipProduct.name}
            />
          )}
        </div>
      </div>

      <div className="row" style={{ paddingTop: "20px" }}>
        <div className="col d-flex align-items-center">
          <p className="mb-0" style={{ fontSize: "14px", color: "#686868" }}>
            Powered by
            <a href="https://www.opendate.io/" target="_blank" rel="noopener noreferrer">
              <img src="/opendate_logo.png" className="ml-2" style={{ width: "88px" }} alt="Opendate" />
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

ExistingMembershipDisplay.propTypes = {
  membership: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    status: PropTypes.string,
    price: PropTypes.number,
    price_to_currency: PropTypes.string,
    interval: PropTypes.string,
    interval_label: PropTypes.string,
    current_period_end: PropTypes.string,
    created_at: PropTypes.string
  }).isRequired,
  membershipProduct: PropTypes.shape({
    name: PropTypes.string.isRequired,
    image_url: PropTypes.string
  }).isRequired,
  venueOwnership: PropTypes.object,
  team: PropTypes.object,
  onBuyAsGift: PropTypes.func
};

ExistingMembershipDisplay.defaultProps = {
  onBuyAsGift: null
};

ExistingMembershipDisplay.defaultProps = {
  venueOwnership: null,
  team: null
};

export default ExistingMembershipDisplay;
